import React, { useState } from 'react';
import { api } from '../lib/api';

const REASONS = [
  ['spam', 'Spam or unwanted selling'],
  ['scam', 'Scam or fraud'],
  ['harassment', 'Harassment or abuse'],
  ['fake', 'Fake profile or impersonation'],
  ['other', 'Something else'],
];

/* Block or report someone, from wherever you meet them. They are never told. */
export default function SafetyMenu({ person, context = '', contextId = '', notify, onDone }) {
  const [open, setOpen] = useState(false);
  const [reporting, setReporting] = useState(false);
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  if (!person?.id) return null;
  const first = (person.name || 'them').split(' ')[0];

  async function block() {
    if (!window.confirm(`Block ${person.name}? You won't be introduced, they can't message you, and you won't see their posts. They won't be told.`)) return;
    setBusy(true);
    try {
      await api.block(person.id);
      notify?.(`${first} is blocked. You can unblock under My profile.`);
      setOpen(false);
      onDone?.();
    } catch (e) {
      notify?.(e.message);
    } finally {
      setBusy(false);
    }
  }

  async function report() {
    setBusy(true);
    try {
      await api.report({ member_id: person.id, reason, note: note.trim(), context_type: context, context_id: contextId });
      notify?.(`Thanks — we'll look into it. ${first} is blocked for you and won't be told.`);
      setOpen(false);
      setReporting(false);
      onDone?.();
    } catch (e) {
      notify?.(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="safety">
      <button className="linklike safety-trigger" aria-haspopup="true" aria-expanded={open}
        aria-label={`More options for ${person.name}`} onClick={() => setOpen(!open)}>⋯</button>
      {open && !reporting && (
        <span className="safety-menu" role="menu">
          <button role="menuitem" onClick={block} disabled={busy}>Block {first}</button>
          <button role="menuitem" onClick={() => setReporting(true)}>Report {first}</button>
        </span>
      )}
      {open && reporting && (
        <div className="safety-report card pad" role="dialog" aria-label={`Report ${person.name}`}>
          <b>Report {person.name}</b>
          <p className="muted-sm">Only the B/N team sees this. {first} is blocked for you and won't be told.</p>
          {REASONS.map(([k, t]) => (
            <label key={k} className="notif-row">
              <input type="radio" name="reason" checked={reason === k} onChange={() => setReason(k)} /> <span>{t}</span>
            </label>
          ))}
          <textarea className="ta" rows={3} maxLength={1000} value={note} placeholder="Anything we should know (optional)"
            onChange={(e) => setNote(e.target.value)} />
          <div className="mp-actions">
            <button className="btn primary sm" disabled={!reason || busy} onClick={report}>
              {busy ? 'Sending…' : 'Send report'}
            </button>
            <button className="btn quiet sm" onClick={() => { setReporting(false); setOpen(false); }}>Cancel</button>
          </div>
        </div>
      )}
    </span>
  );
}
